<template>
  <div>
    <van-nav-bar
      title="购物车"
      left-text="返回"
      left-arrow
      @click-left="gohome"/>
    <!-- <van-loading vertical v-if="loading"/> -->
    <van-checkbox-group class="card-goods" v-model="checkedGoods" v-if="!loading">
      <div v-if="goods.length == 0" class="emptyinfo">
        <div class="info">购物车空空如也...</div>
        <div class="cmd" @click="gohome">添加商品</div>
      </div>
      <div v-if="goods.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad">
          <van-checkbox
            class="card-goods__item"
            v-for="item in goods"
            :key="item.id"
            :name="item.id"
            @click="clickCheck(item)">
            <van-card
              :title="item.car_products_name"
              :price="item.price"
              :thumb="item.img">
              <div slot="desc">
                {{ item.version_name }}<br/>{{ item.car_products_spc }}
              </div>
              <div slot="num">
                <van-stepper
                  v-model="item.qty"
                  step="1"
                  input-width="40px"
                  button-size="10px"
                  @change="chgNum(item)"/>
              </div>
            </van-card>
          </van-checkbox>
        </van-list>
      </div>
    </van-checkbox-group>
    <van-submit-bar
      :price="sum * 100"
      :disabled="!count"
      :button-text="submitBarText"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { CartApi } from '@/api/market'
import { toErrorPage } from '@/utils/usePage'
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Stepper,
  NavBar,
  Loading,
  NoticeBar,
  List
} from 'vant';

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Stepper.name]: Stepper,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [NoticeBar.name]: NoticeBar,
    [List.name]: List
  },

  data() {
    return {
      checkedGoods: [],
      goods: [],
      sum: 0,
      count: 0,
      loading: false,
      finished: false,
      total: 0,
      query: {
        page: 1
      }
    };
  },
  mounted() {
    this.getData()
  },
  computed: {
    submitBarText() {
      return '结算' + (this.count ? `(${this.count})` : '');
    },

    totalPrice() {
      return this.goods.reduce((total, item) => total + (this.checkedGoods.indexOf(item.id) !== -1 ? item.price : 0), 0);
    }
  },

  methods: {
    getData() {
      this.loading = true
      var that = this
      that.axios.get(CartApi, {params: that.query}).then((ret) => {
        that.loading = false
        if(ret.hasOwnProperty("flag")) { 
          toErrorPage(that,'',ret.info,null)
        } else {
          ret.results.forEach(it => {
            it.status = false
            that.sum = 0
          })
          that.total= ret.count
          if (ret.results == null || ret.results.length ===0 ) {
            that.finished = true
            return
          }
          that.goods = that.goods.concat(ret.results)
          if (that.goods.length >= that.total) {
            that.finished = true
          }
          this.mathCart()
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    onLoad() {
      this.query.page = this.query.page + 1
      this.getData()
    },
    chgData(itm) {
      this.loading = true
      var that = this
      that.axios.put(CartApi + itm.id + '/', itm).then((ret) => {
        console.log(ret)
        that.loading = false
      }).catch((ex) => {
        that.loading = false
        console.log(ex)
      })
    },
    chgNum(itm) {
      this.chgData(itm)
      this.mathCart()
      event.stopPropagation()
    },
    clickCheck(itm) {
      itm.checked = !itm.checked
      this.chgData(itm)
      this.mathCart()
    },
    mathCart() {
      let _sum = 0
      let _count = 0
      const ids = []
      this.goods.forEach((it) => {
        if (it.checked) {
          _sum = _sum + Number(it.qty) * Number(it.price)
          _count = _count + Number(it.qty)
          ids.push(it.id)
        }
      })
      this.sum = _sum
      this.checkedGoods = ids
      this.count = _count
    },
    gohome() {
      this.$router.push(`/home`)
    },
    clickback() {
      this.$router.push(`/home`)
      // try {
      //   this.$router.go(-1)
      // } catch {
      //   this.$router.push(`/home`)
      // }
    },
    onSubmit() {
      this.loading = true
      let items = []
      var that = this
      this.goods.forEach((it) => {
        that.loading = false
        if (it.checked) {
          items.push({
            version_id: it.car_products,
            version_name: it.version_name,
            prd1_id: it.prod1_id,
            prd_name: it.car_products_name,
            cls: it.cls,
            cls1: it.cls1,
            qty: it.qty,
            price: it.price,
            img: it.img
          })
        }
      })
      const data = {
        source: 'cart',
        data: items
      }
      this.$router.push({
        name: 'order',
        query: JSON.stringify(data)
      })
    }
  }
};
</script>

<style lang="less">
.card-goods {
  padding: 10px 0;
  background-color: #fff;

  &__item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }

  .emptyinfo {
    text-align: center;

    .info {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .cmd {
      margin-top: 10px;
      color: #f44;
    }
  }
}
</style>
